
import Vue from 'vue'
import { Context } from '@nuxt/types'

export default Vue.extend({
  scrollToTop: true,
  async asyncData({ $content, params }: Context): Promise<{ page: object }> {
    const page: object = await $content(params.id).fetch()

    return {
      page,
    }
  },
  data() {
    return {
      myPic: require('../../assets/mypic.jpg'),
    }
  },
  head() {
    return {
      title: (this as any).page.title,
    }
  },
})
